import { FieldDefType } from 'tsui/lib/ts-table/ts-table.model';
import { AccountingReportGridComponent } from '../components/accounting-report/accounting-report-grid.component';
import { RegularAccount } from '../models';

export namespace AccountMappingUtils {
  const mappedAccountColumns = {
    'gl_account.gl_account_number': {
      label: 'Account Number',
      type: 'text',
      flex: 0,
    },
    'gl_account.gl_account_name': {
      label: 'Account Name',
      type: 'text',
      flex: 1,
    },
    'gl_category.name': {
      label: 'TermSheet Category',
      type: 'text',
    },
  };

  export const unmappedAccountColumns: {
    [key in RegularAccount['gl_account_name'] | RegularAccount['gl_account_number']]: any;
  } = {
    gl_account_number: {
      label: 'Imported Account Number',
      type: 'text',
      flex: 0,
      minWidth: 200,
    },
    gl_account_name: {
      label: 'Imported Account Name',
      type: 'text',
      flex: 1,
    },
  };

  const createColumnDefs = (columns: Record<string, any>) =>
    Object.entries(columns).map(([key, val]) => ({
      label: val.label,
      name: key,
      type: val.type as FieldDefType,
      ...AccountingReportGridComponent.commonColumnDefParams(key, val.label, val?.minWidth, val?.flex),
    }));

  export const mappedColumnDefs = createColumnDefs(mappedAccountColumns);
  export const unmappedColumnDefs = createColumnDefs(unmappedAccountColumns);
}
